<section
    class=" content2-bg-image no-padding cover-background xs-bg-none border-none bg-img-ten header-margin-top-medium"
    id="" data-img-size="(W)1920px X (H)590px"
    style="background: linear-gradient(rgba(0, 0, 0, 0.00784314), rgba(0, 0, 0, 0.00784314)), url('assets/images/bg-image/bg-home-empresa.jpg') fixed;">
    <div class="container sm-width-100 sm-no-padding">
        <div
            class="bg-cream  width-80 sm-width-60 xs-width-100 content-style1 padding-four md-padding-eight sm-padding-eighteen">
            <!-- title -->
            <h2
                class="title alt-font title-extra-large font-weight-500 sm-title-extra-large-2 xs-section-title-large text-brown margin-one-bottom">
                Cómo funciona</h2>
            <!-- end  title -->
            <div class="text-medium sm-text-medium text-dark-gray margin-one-bottom">
                <p>La subasta de ganado online es un sistema de comercialización 100% confiable. Tropeando te permite
                    comprar lotes desde tu establecimiento u hogar, siempre que tengas acceso a internet.</p>
                <p>Para realizar operaciones de compra, necesitarás registrarte y luego recibirás una autorización vía
                    correo electrónico.</p>
            </div>
            <div class="btn-dual margin-five">
                <a class="btn btn-large  btn-circle bg-dark-brown text-white inner-link" routerLink="/registro"
                    routerLinkActive="active"><span>REGISTRARSE ACÁ</span></a>
            </div>
            <!-- title -->
            <h3 class="title-medium font-weight-600">Sistema de ventas</h3>
            <!-- end  title -->
            <div class="text-medium sm-text-medium text-dark-gray">
                <p>De común acuerdo con el propietario del ganado, determinamos uno de los 3 sistemas de ventas.</p>
            </div>
            <div class="row">
                <div class="col-md-12 col-sm-12 col-xs-12">
                    <!-- feature box -->
                    <div class="col-md-12 col-sm-6 col-xs-12 sm-margin-nine-bottom xs-margin-nineteen-bottom">
                        <h3
                            class="text-medium text-dark-gray alt-font margin-three-bottom display-block sm-margin-nine-bottom xs-margin-five-bottom  font-weight-600">
                            SISTEMA 1</h3>
                        <div class="text-medium ">
                            <p>El lote entra a subasta únicamente con la opción de pujas, arrancando con un precio base.
                            </p>
                            <p>Las pujas son de Gs. 20.000 o sus múltiplos.</p>
                            <p>El botón negro indica el arranque del lote por el precio base.</p>
                            <p>
                                <a class="btn btn-large propClone btn-circle bg-dark-gray text-white margin-one"
                                    href="javascript:void(0)">
                                    <span id="">¿ARRANCAMOS?<br><span class="title-medium">Gs. 2.000.000</span></span>
                                </a>
                            </p>
                            <p>El botón verde indica que el usuario tiene la última puja, pudiendo a la vez seguir
                                aumentando su propia puja.</p>
                            <p>
                                <a class="btn btn-large propClone btn-circle text-white margin-one bg-deep-green"
                                    href="javascript:void(0)">
                                    <span id="">¡PÓNGALE UNA PUJA!<br><span class="title-medium">Gs.
                                            2.020.000</span></span>
                                </a>
                            </p>
                            <p>El botón amarillo indica que el usuario <b>no tiene la última puja.</b></p>
                            <p>
                                <a class="btn btn-large propClone btn-circle text-white margin-one bg-yellow"
                                    href="javascript:void(0)">
                                    <span id="">¡PÓNGALE UNA PUJA!<br><span class="title-medium">Gs.
                                            2.040.000</span></span>
                                </a>
                            </p>
                            <p>El botón rojo indica que el lote está vendido.</p>
                            <p>
                                <a class="btn desactivado btn-large propClone btn-circle bg-deep-red text-white margin-one"
                                    href="javascript:void(0)">
                                    <span id="">VENDIDO <span class="fas fa-gavel rotate title-medium "></span><br><span
                                            class="title-medium">Gs. 2.060.000</span></span>
                                </a>
                            </p>
                        </div>
                    </div>
                    <!-- end feature box -->
                    <!-- feature box -->
                    <div class="col-md-12 col-sm-6 col-xs-12 sm-margin-nine-bottom xs-margin-nineteen-bottom">
                        <h3
                            class="text-medium text-dark-gray alt-font margin-three-bottom display-block sm-margin-nine-bottom xs-margin-five-bottom  font-weight-600">
                            SISTEMA 2</h3>
                        <div class="text-medium ">
                            <p>El lote entra a subasta únicamente con la opción de compra directa.</p>
                            <p>En este sistema el botón negro indica la compra directa del lote, en el precio
                                establecido</p>
                            <p>
                                <a class="btn btn-large propClone btn-circle bg-dark-gray text-white margin-one"
                                    href="javascript:void(0)">
                                    <span id="">COMPRA DIRECTA<br><span class="title-medium">Gs. 2.500.000</span></span>
                                </a>
                            </p>
                            <p>El sistema 2 de compra directa se presenta en el botón de color negro y una vez
                                concretado se convierte en Rojo.</p>
                        </div>
                    </div>
                    <!-- end feature box -->
                    <!-- feature box -->
                    <div class="col-md-12 col-sm-6 col-xs-12 sm-margin-nine-bottom xs-margin-nineteen-bottom">
                        <h3
                            class="text-medium text-dark-gray alt-font margin-three-bottom display-block sm-margin-nine-bottom xs-margin-five-bottom  font-weight-600">
                            SISTEMA 3</h3>
                        <div class="text-medium ">
                            <p>El lote entra a subasta con pujas que arrancan con un precio base y con la opción de
                                compra directa</p>
                            <div>
                                <h2 class="title-extra-large-2 width-100 text-dark-gray">Precio base: <strong>Gs.
                                        2.000.000 </strong></h2><br>
                                <a class="btn btn-large propClone btn-circle bg-dark-gray text-white margin-one"
                                    href="javascript:void(0)">
                                    <span id="">¿ARRANCAMOS?<br>
                                        <span class="title-medium">Gs. 2.000.000</span>
                                    </span>
                                </a> <br>
                                <a class="btn btn-large propClone btn-circle bg-dark-gray text-white margin-one"
                                    href="javascript:void(0)">
                                    <span id="">COMPRA DIRECTA<br>
                                        <span class="title-medium">Gs. 2.500.000</span>
                                    </span>
                                </a>
                            </div>
                            <p>La subasta contempla las opciones del sistema 1 y 2 (con pujas y compra directa).</p>
                        </div>
                    </div>
                    <!-- end feature box -->
                </div>
            </div>
            <!-- title -->
            <h3 class="title-medium font-weight-600">Tiempo del lote en subasta</h3>
            <!-- end  title -->
            <div class="text-medium sm-text-medium text-dark-gray">
                <p>Los Sistemas de ventas, cuentan con un cronómetro en retroceso que marca los días, horas, minutos y
                    segundos de culminación de la subasta. </p>
                <p>
                    <strong _ngcontent-c4="" class="title-medium text-red">
                        <i _ngcontent-c4="" class="fas fa-clock "></i> Subasta finaliza en <span>
                            <div _ngcontent-c3="" class="countdown">
                                <div _ngcontent-c3="" class="measurements  d ">
                                    <p _ngcontent-c3="" class="measurements-number"> 2 </p>
                                    <span _ngcontent-c3="" class="divider"> </span>
                                    <p _ngcontent-c3="" class="measurements-text"> d </p>
                                </div>
                                <div _ngcontent-c3="" class="measurements   h ">
                                    <p _ngcontent-c3="" class="measurements-number"> 21 </p>
                                    <span _ngcontent-c3="" class="divider"> </span>
                                    <p _ngcontent-c3="" class="measurements-text"> h </p>
                                </div>
                                <div _ngcontent-c3="" class="measurements   m ">
                                    <p _ngcontent-c3="" class="measurements-number"> 11 </p>
                                    <span _ngcontent-c3="" class="divider"> </span>
                                    <p _ngcontent-c3="" class="measurements-text"> m </p>
                                </div>
                                <div _ngcontent-c3="" class="measurements   s">
                                    <p _ngcontent-c3="" class="measurements-number"> 21 </p>
                                    <p _ngcontent-c3="" class="measurements-text"> s </p>
                                </div>
                            </div>
                        </span>
                    </strong>
                </p>
            </div>
            <!-- title -->
            <h3 class="title-medium font-weight-600">¿Como sigo la subasta del lote?</h3>
            <!-- end  title -->
            <div class="text-medium sm-text-medium text-dark-gray">
                <p>Los interesados podrán seguir al lote apretando el botón Seguir (debajo del video) y de esta manera,
                    recibirán notificaciones en sus celulares que le informarán la evolución del mismo. </p>
                <p><a class="btn btn-small propClone btn-circle bg-dark-brown text-white font-weight-500"><span class=""
                            id="">SEGUIR <i class="far fa-bell"></i></span></a>
                    <span> <i class="far fa-user text-light-gray2"></i></span>
                    <span class="text-light-gray2"> 16 siguiendo este lote</span>
                </p>
            </div>
            <!-- title -->
            <h3 class="title-medium font-weight-600">Periodo aleatorio</h3>
            <!-- end  title -->
            <div class="text-medium sm-text-medium text-dark-gray">
                <p>Al culminar el tiempo del lote en subasta, el sistema establece un periodo aleatorio donde los
                    usuarios podrán seguir pujando por más de que el tiempo se haya agotado.</p>
                <p>Esto es a modo de evitar especulaciones con el tiempo y permitir a los usuarios que realizaron pujas
                    anteriores mejorar la última oferta. </p>
                <p><strong class="title-medium text-red"><img class="padding-one-half"
                            src="assets/images/reloj.gif">Estamos en el periodo aleatorio </strong></p>
            </div>
        </div>
    </div>
</section>
